module.exports = __webpack_public_path__ + "img/holds_2.ccf4a86a.png";